"use strict";

require('./controller');
require('./directives');
require('./filters');
require('./services');
require('./routes');